import * as apiVendors from 'api/apiVendors';
import type { ContactsAdapter } from 'modules/client';

export const createVendorPersonContactsAdapter = (vendorId: number): ContactsAdapter => ({
    list: (personId) => apiVendors.getVendorPersonContacts(vendorId, personId),
    add: (personId, contact) => apiVendors.addVendorPersonContact(vendorId, personId, contact),
    update: (personId, contactId, contactValue) =>
        apiVendors.updateVendorPersonContact(vendorId, personId, contactId, contactValue),
    remove: (personId, contactId) => apiVendors.deleteVendorPersonContact(vendorId, personId, contactId),
});
